import { useEffect, useState } from "react";
import { MessageSquareReply } from "lucide-react";
import api from "../../lib/api";
import { fmtDT } from "../../lib/outreach";

export default function NeedsReviewPanel({ reloadKey }) {
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/outreach/needs-review").then(({ data }) => setItems(data)).catch(() => setItems([]));
  }, [reloadKey]);

  if (!items.length) return null;
  return (
    <div data-testid="needs-review-panel" className="rounded-xl border border-amber-500/30 bg-amber-500/5 p-5 mb-6">
      <h2 className="font-display font-bold text-base inline-flex items-center gap-2 text-amber-300 mb-3">
        <MessageSquareReply className="w-5 h-5" /> Needs review ({items.length})
      </h2>
      <ul className="divide-y divide-slate-800">
        {items.map((l) => (
          <li key={l.id} data-testid={`needs-review-${l.id}`} className="py-2.5 flex flex-col sm:flex-row sm:items-center gap-1 sm:gap-4">
            <a href={`/app/leads/${l.id}#replies`} target="_blank" rel="noreferrer" className="font-semibold text-white hover:text-amber-400 transition-colors shrink-0">
              {l.company_name}
            </a>
            <span className="text-xs text-slate-400 shrink-0">{l.contact_name || l.email} · {fmtDT(l.last_reply_at)}</span>
            <span className="text-xs text-slate-300 truncate">{l.last_reply_snippet}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
